import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { QuantityInput } from 'cat-ecommerce-alloy';
import styles from '../CustomizeModalTable.module.scss';

export const QuantityInformation = ({
  productInfo,
  setItemsDisabledButtonList,
  setDebouncedItems
}) => {
  const [value, setValue] = useState(productInfo.quantity);
  const MAX_QUANTITY = 99999;

  useEffect(() => {
    // * Disables add-to-cart button if the item quantity is above limit
    if (productInfo.quantity === 0 || productInfo.quantity > MAX_QUANTITY) {
      setItemsDisabledButtonList(oldArray => [
        ...oldArray,
        { uniqueId: productInfo.key, quantity: productInfo.quantity }
      ]);
    } else {
      setItemsDisabledButtonList(oldArray =>
        oldArray.filter(item => item.uniqueId !== productInfo.key)
      );
    }
  }, [productInfo.quantity]);

  const maxValueHandler = value => {
    if (value < MAX_QUANTITY) {
      setValue(value);
    } else {
      setValue(MAX_QUANTITY);
    }
  };

  const onQuantityChange = value => {
    const intValue = parseInt(value);
    const newValue = intValue > MAX_QUANTITY ? MAX_QUANTITY : intValue;
    const part = {
      partNumber: productInfo.partNumber,
      uniqueId: productInfo.key,
      quantity: newValue
    };
    setDebouncedItems(prev => [
      ...prev.filter(item => item.uniqueId !== part.uniqueId),
      part
    ]);

    // * Disable button to avoid user from clicking it during the debounce time
    const disableItem = {
      uniqueId: productInfo.key,
      quantity: newValue
    };
    setItemsDisabledButtonList(oldArray => {
      const filteredArray = oldArray.some(
        item => item.uniqueId === disableItem.uniqueId
      )
        ? oldArray.filter(item => item.uniqueId !== disableItem.uniqueId)
        : [...oldArray];
      return [...filteredArray, disableItem];
    });
  };

  return (
    <div className={styles['quantity-picker']}>
      <QuantityInput
        onChange={e => onQuantityChange(e.target.value)}
        onDecrement={value => onQuantityChange(+value - 1)}
        onIncrement={value => onQuantityChange(+value + 1)}
        setValue={value => maxValueHandler(value)}
        maxValue={MAX_QUANTITY}
        minValue="0"
        value={value}
      />
    </div>
  );
};

QuantityInformation.propTypes = {
  productInfo: PropTypes.object,
  setItemsDisabledButtonList: PropTypes.func,
  setDebouncedItems: PropTypes.func
};
